import { O_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { HPreparePrice } from "@rf-helper/property/prepare-price-property";

export const prepareDetailPropertyPrice = (data: IPropertyDetailsResponse) => {
  return HPreparePrice({
    alternativePrice: data?.alternate_price?.toString() ?? "",
    currencyAlternativePrice: data?.alternative_currency_symbol ?? "",
    currencyPrice: data?.currency_symbol ?? "",
    businessTypeId: O_BUSINESS_TYPE[data.business_type].id,
    isProject: Boolean(data.project),
    price: data.price,
    maximumPrice: data.maximum_price ? data.maximum_price.toString() : "",
    minimumPrice: data.minimum_price ? data.minimum_price.toString() : "",
    mode: "detail"
  });
};
